import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import * as moment from 'moment';
import { MedReviewService } from '../../services/med-review.service';
import { StringUtilsService } from '../../../../../core/services/string-utils.service';
import { FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { FollowUpDialogComponent } from '../../../follow-up/follow-up-dialog/follow-up-dialog.component';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { BehaviorSubject, of } from 'rxjs';
import { DrpComponent } from '../../drp/drp.component';
import { PatientsService, ViewContext } from '../../../../../core/lists';
import { take } from 'rxjs/operators';
import { CommentsDialogComponent } from '../../../../partials/content/general/comments-dialog/comments-dialog.component';
import { CommentsService } from '../../../../../core/services/comments.service';
import { NavigationService } from '../../../../../core/services/navigation.service';
import { ContextualHistoryService } from '../../../../partials/content/general/contextual-history/services/contextual-history.service';
import { MedReviewConfigKey } from '../../models';
import { TaskMode } from '../../../calendar/enums';
import { CreateTaskComponent } from '../../../calendar/create-task/create-task.component';
import { TaskEntity } from '../../../calendar/models';
import { TemplateService } from '../../../../../core/lists/_services/template.service';
import { BambooHealthDataComponent } from '../bamboo-health-data/bamboo-health-data.component';

@Component({
  selector: 'kt-med-review-board-header',
  templateUrl: './med-review-board-header.component.html',
  styleUrls: ['./med-review-board-header.component.scss'],
})
export class MedReviewBoardHeaderComponent implements OnInit, OnChanges, OnDestroy {
  private subscriptions: any[] = [];
  @Input() data;
  @Input() readonly = false;
  fromMedReviewList = true;
  @Input() hasMedReviewSub: BehaviorSubject<boolean>;
  @Output() toggleViewMode = new EventEmitter<any>();
  showWarning = false;
  showWarningdr = false;
  showWarningOb = new BehaviorSubject(false);
  showWarningDRP = new BehaviorSubject(false);
  medWiseRiskScore: any;
  medWiseRiskScoreString: any;
  mrsBarColor;
  medType = new FormControl('');
  showArrows: any;
  isViewMode = false;
  relatedTaskTemplates = [];
  @Input() bambooHealthData;
  remainingNarxScores: any[] = [];
  datanotfound = false;
  overdoseLevel = {
    label: '',
    color: '',
  };

  get clinicalCheckFailed(): boolean {
    return this.bambooHealthData?.status === 'FAILED';
  }

  get showClinicalCheckBox(): boolean {
    if (this.clinicalCheckFailed) {
      return true;
    }
    const results = this.bambooHealthData?.engineResults;
    return !Array.isArray(results) || results.length > 0;
  }
  constructor(
    public dialog: MatDialog,
    private patientsService: PatientsService,
    private route: ActivatedRoute,
    private medReviewService: MedReviewService,
    private commentsService: CommentsService,
    private contextualHistoryService: ContextualHistoryService,
    private router: Router,
    private cdr: ChangeDetectorRef,
    public stringUtils: StringUtilsService,
    private navigationService: NavigationService,
    private templateService: TemplateService,
  ) {}

  ngOnInit(): void {
    this.medReviewService.getMedReviewsFromLocalStorage();
    this.medReviewService.updateMedReviewIndex(this.data.id);

    if (window.location.href.indexOf('med-review/board') === -1) {
      this.fromMedReviewList = false;
    }
    this.showArrows = this.fromMedReviewList
      ? this.medReviewService.getMedReviewIndex() > -1
      : false;
    // tslint:disable-next-line:triple-equals
    this.route.url.subscribe(() => {
      setTimeout(() => {
        this.showWarning = this.data.medications.filter((e) => e.is_verify == '0').length > 0;
        this.showWarningOb.next(this.showWarning);
        this.checkDrpsExist();
        this.medReviewService.getMedScore([this.data.patient_id]).subscribe((res) => {
          res = res[0] || { mrs: 0 };
          this.medWiseRiskScore = res.mrs;
          if (res.mrs >= 36) {
            this.medWiseRiskScoreString = 'Very High';
            this.mrsBarColor = '#ed2024';
          } else if (res.mrs >= 20) {
            this.medWiseRiskScoreString = 'High';
            this.mrsBarColor = '#f8991c';
          } else if (res.mrs >= 13) {
            this.medWiseRiskScoreString = 'Moderate';
            this.mrsBarColor = '#fbcd09';
          } else if (res.mrs >= 6) {
            this.medWiseRiskScoreString = 'Low';
            this.mrsBarColor = '#f9f49d';
          } else {
            this.medWiseRiskScoreString = 'Very Low';
            this.mrsBarColor = '#9fc9eb';
          }
          this.cdr.detectChanges();
        });
        this.medReviewService.getUpdatePV1Warning().subscribe(() => {
          this.showWarning = this.data.medications.filter((e) => e.is_verify == '0').length > 0;
          this.showWarningOb.next(this.showWarning);
          this.cdr.detectChanges();
        });
        this.medReviewService.getUpdateDRP().subscribe(() => {
          this.checkDrpsExist();
        });
        this.medType.valueChanges.subscribe((value) => {
          this.medReviewService.updatePatientMedReviewFilter(value);
        });
      }, 30);
    });
    if (this.route.url[`_value`][1]?.path === 'view') {
      this.isViewMode = true;
    }
    this.contextualHistoryService.setFieldsData('/med-review/board', null, [this.data.patient_id]);

    this.subscriptions.push(
      this.medReviewService.getMedReviewConfigs().subscribe((res) => {
        if (!res?.length) return;

        this.relatedTaskTemplates = JSON.parse(
          res.find((c) => c.key === MedReviewConfigKey.RELATED_TASK_TEMPLATES)?.value || '[]',
        );
      }),
    );
  }

  showBambooData() {
    this.dialog.open(BambooHealthDataComponent, {
      data: {
        medReviewId: this.data.id,
        bambooHealthData: this.bambooHealthData,
        remainingNarxScores: this.remainingNarxScores,
      },
      width: '600px',
      height: '500px',
    });
  }
  getOverdoseLevel(value: string | number): {
    label: string;
    color: string;
  } {
    const score = Number(value);

    if (score <= 199) {
      return {
        label: 'Low',
        color: 'ks-text-neutral',
      };
    }
    if (score <= 399) {
      return {
        label: 'Moderate',
        color: 'ks-text-warning',
      };
    }
    if (score <= 650) {
      return {
        label: 'High',
        color: 'ks-text-dark-warning',
      };
    }
    return {
      label: 'Critical',
      color: 'ks-text-danger',
    };
  }
  getRemainingScoreColor(value: string | number): string {
    return this.getOverdoseLevel(value).color;
  }
  checkDrpsExist() {
    if (!this.data || !this.data.patient_id) {
      return;
    }
    const countSubscription = this.medReviewService
      .getDrpCount(this.data.patient_id)
      .subscribe((res: any) => {
        if (res && (res.active > 0 || res.potential > 0)) {
          this.showWarningdr = true;
          this.showWarningDRP.next(this.showWarningdr);
        }
        if (res && res.active === 0 && res.potential === 0) {
          this.showWarningdr = false;
          this.showWarningDRP.next(this.showWarningdr);
        }
      });
    this.subscriptions.push(countSubscription);
  }
  onWarningClicked($event: MouseEvent) {
    if (this.showWarning) this.toggleViewMode.emit($event);
  }

  getMedWiseRiskScore() {
    return (this.medWiseRiskScore / 50) * 100 + '%';
  }

  formatDate(date) {
    if (moment.isDate(new Date(date))) {
      return moment(date).format('MM-DD-YYYY');
    }
  }

  completeMedReview() {
    this.medReviewService.completeMedReview(this.data.id).subscribe(() => {
      if (this.fromMedReviewList) return this.router.navigateByUrl('/med-review');
      this.hasMedReviewSub?.next(false);
    });
  }

  completeAndNext() {
    this.medReviewService.completeMedReview(this.data.id).subscribe(() => {
      this.medReviewService.removeMedReviewFromChain();
    });
  }

  navigateToPatient(data) {
    if (this.fromMedReviewList) {
      const queryParams = {
        viewContext: ViewContext.patients,
      };
      this.navigationService.navigateTo('lists/patients/edit/' + data.patient_id, queryParams);
    }
  }

  getIndicators() {
    return this.medReviewService.getIndicators(this.data.indicators);
  }

  getCycleDateString() {
    return this.stringUtils.formatDate(this.data.facility_cycle_date, 'MM-dd-yyyy');
  }

  nextMedReview() {
    const myButton = document.getElementById('nextMed') as HTMLButtonElement;
    myButton.disabled = true;
    this.medReviewService.nextMedReview();
  }

  previousMedReview() {
    const myButton = document.getElementById('previousMed') as HTMLButtonElement;
    myButton.disabled = true;
    this.medReviewService.previousMedReview();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.bambooHealthData?.currentValue) {

      const message = (
        this.bambooHealthData?.engineResults[0]?.riskScore?.reportMessage || ''
      ).toLowerCase();
      this.datanotfound =
        message.includes('pmp') &&
        message.includes('data') &&
        (message.includes('not found') ||
          message.includes('did not find') ||
          message.includes('unable to find'));

      const narxScores = this.bambooHealthData?.engineResults?.[0]?.riskScore?.narxScores;

      if (narxScores) {
        const overdoseScore = Number(narxScores.Overdose);

        if (!isNaN(overdoseScore)) {
          this.overdoseLevel = this.getOverdoseLevel(overdoseScore);
        }

        this.remainingNarxScores = Object.entries(narxScores)
          .filter(([name]) => name !== 'Overdose')
          .map(([name, value]) => {
            const numericValue = Number(value);

            return {
              name,
              value: String(value),
              rx: numericValue % 10,
              color: this.getRemainingScoreColor(numericValue),
            };
          })
          .sort((a, b) => Number(b.value) - Number(a.value));
      } else {
        // Clear old data if Bamboo data disappears/changes
        this.overdoseLevel = {
          label: '',
          color: '',
        };

        this.remainingNarxScores = [];
      }
    }


    if (changes.data && !changes.data.firstChange) {
      this.showWarning = this.data.medications.filter(
        (e) => e.is_verify == '0'
      ).length > 0;

      this.showWarningOb.next(this.showWarning);
      this.checkDrpsExist();
    }

    this.cdr.detectChanges();
  }

  openFollowUpDialog(element) {
    this.dialog.open(FollowUpDialogComponent, {
      data: {
        body: element,
        type: 'MEDREVIEW',
        title: element.patient_name,
        relatedIds: [element.patient_id],
      },
      width: '1200px',
    });
  }
  openDrpDialog() {
    if (this.showWarningdr === true) {
      this.patientsService.getPatientByIds([this.data.patient_id]).subscribe((resPatients) => {
        const dialogRef = this.dialog.open(DrpComponent, {
          data: {
            patient: resPatients.data[0],
          },
          width: '95vw',
          maxWidth: '95vw',
          height: '95vh',
        });
        dialogRef.afterClosed().subscribe(() => {
          this.medReviewService.emitDRP();
        });
      });
    }
  }

  openMedwiseTab() {
    window.open('https://www.medwise.com', '_blank');
  }

  openCommentsDialog(event: Event, medReviewId: number): void {
    event.stopPropagation();

    this.commentsService
      .getComments('medreviews', medReviewId)
      .pipe(take(1))
      .subscribe(({ data }) => {
        this.dialog.open(CommentsDialogComponent, {
          width: '450px',
          data: {
            height: 40,
            transactionType: 'medreviews',
            transactionId: medReviewId,
            comments: data,
          },
        });
      });
  }
  ngOnDestroy(): void {
    this.subscriptions.forEach((el) => el.unsubscribe());
  }

  createTask(event: Event, templateId: number): void {
    event.stopPropagation();

    const dialogConfig = new MatDialogConfig();
    const entities: Partial<TaskEntity>[] = [
      { entity_id: this.data.patient_id },
      { entity_id: this.data.facility_id },
    ];

    dialogConfig.disableClose = true;
    dialogConfig.closeOnNavigation = true;
    dialogConfig.width = '95vw';
    dialogConfig.maxWidth = '95vw';

    const getTemplateSteps$ = templateId
      ? this.templateService.getTaskTemplateSteps(templateId)
      : of({ data: { additional_step_template_dtos: null } });

    getTemplateSteps$.pipe(take(1)).subscribe((res) => {
      if (!res?.data) return;

      dialogConfig.data = {
        mode: TaskMode.CREATE,
        templateSteps: res.data.additional_step_template_dtos,
        entities,
      };

      this.dialog.open(CreateTaskComponent, dialogConfig);
    });
  }
}
